import React from 'react'
import { Resource } from '@/payload-types'
import { HeroBlock, Blocks } from '@/components'
import { RichText } from '@payloadcms/richtext-lexical/react'

interface ResourceDetailProps {
  page: Resource
}

function ResourceDetail({ page }: Readonly<ResourceDetailProps>) {
  return (
    <main className="flex-1 flex flex-col gap-4 mt-12">
      <HeroBlock title={page.title} lead={page.lead} blockType="hero" />
      <section className="max-w-4xl mx-auto p-4">
        {page.content && <RichText data={page.content} className="prose prose-neutral" />}
      </section>
      {page.blocks && <Blocks blocks={page.blocks} />}
    </main>
  )
}

export { ResourceDetail }
